import { ActionMenu } from '@monorepo/shared/componentsV2/menus/ActionMenu';
import { header2 } from '@monorepo/shared/styles/text';
import { FormTemplateResponse } from 'mapistry-shared';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { EditSectionNameModal } from './EditSectionNameModal/EditSectionNameModal';

type EditableSectionNameProps = {
  activeGroupId: string;
  updateGroupName: (name: string) => void;
  formTemplate: FormTemplateResponse;
};

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 0.15em 1.5em;
  margin-bottom: 2em;
  background-color: ${({ theme }) => theme.colors.grayeee};
  border-radius: 0.3rem;
`;

const SectionNameDisplay = styled('h2')`
  flex-grow: 1;
  ${header2}
`;

export function EditableSectionName({
  activeGroupId,
  updateGroupName,
  formTemplate,
}: EditableSectionNameProps) {
  const activeGroupName =
    formTemplate.groups.find((group) => group.id === activeGroupId)?.name || '';

  const [nameModalIsOpen, setNameModalIsOpen] = useState(false);

  const openEditNameModal = useCallback(() => {
    setNameModalIsOpen(true);
  }, [setNameModalIsOpen]);

  const closeEditNameModal = useCallback(() => {
    setNameModalIsOpen(false);
  }, [setNameModalIsOpen]);

  return (
    <Container>
      <SectionNameDisplay>{activeGroupName}</SectionNameDisplay>
      <ActionMenu
        color="secondary"
        options={[{ displayName: 'Rename', onClick: openEditNameModal }]}
      />
      {!!nameModalIsOpen && (
        <EditSectionNameModal
          isOpen={!!nameModalIsOpen}
          closeEditNameModal={closeEditNameModal}
          updateGroupName={updateGroupName}
          name={activeGroupName}
          formTemplate={formTemplate}
        />
      )}
    </Container>
  );
}
